export default __webpack_public_path__ + "static/media/itc.bf250523.png";